import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  AmountType,
  ClientPurse,
  ClientPurseResponse,
  Gateway,
  GatewayResponse,
  UpdateAmount,
  UpdateProcessingMethod,
  WithdrawalApproveRequest,
  WithdrawalEdit,
  WithdrawalStatus,
  DividendBalance,
  dividendBalanceDefault,
  WithdrawalDecisionCheck,
  DisableAutoWithdrawalParams,
  ApiError,
  RequestState,
  GatewaysStatusResponse,
  GatewayCountries,
} from './types'
import { $params } from '../../../../features/router'
import Decimal from 'decimal.js'
import { Error } from '../../../clients/edit/types'
import { env } from '../../../../libs/constants'
import { comment } from '../../../../views/widgets/commentForm/model'
import { setRequestSuccess, setRequestError } from '../../../../features/notifications'
import { PaymentTraffic } from 'src/pages/billing/paymentTrafficMonitoring/types'

export const withdrawalMounted = createEvent()
export const setWithdrawal = createEvent<WithdrawalEdit>()
export const submitEditWithdrawal = createEvent<WithdrawalEdit>()
export const submitEditWithdrawalAmount = createEvent<UpdateAmount>()
export const submitEditWithdrawalProcessingMethod =
  createEvent<UpdateProcessingMethod>()
export const setAmount = createEvent<UpdateAmount>()
export const submitStatus = createEvent<WithdrawalStatus>()
export const submitReject = createEvent<WithdrawalStatus>()
export const submitRollback = createEvent<WithdrawalStatus>()
export const $amount = restore(setAmount, {
  amount: {
    initialAmount: new Decimal(0),
    initialCurrency: '',
    initialCurrencyVisited: false,
    initialAmountVisited: false,
    clientAmount: new Decimal(0),
    clientCurrency: '',
    clientAmountVisited: false,
    clientCurrencyVisited: false,
  },
  withdrawal: {
    formDataFieldSequenceOrder: [],
    dealerApprovalStatus: '',
    transactionId: '',
    initialAmountUsd: '',
    gatewayId: '',
    mtTransactionId: 0,
    clientId: '',
    gateway: {
      gatewayId: 0,
      internalName: '',
      paymentMethodType: '',
      processingProvider: '',
      withdrawalGroupId: 0,
      name: '',
      exchanger: {
        id: '',
        frontName: '',
        balance: '',
      },
    },
    formData: {
      amount: '',
      address: '',
      toBankAccountName: '',
      toBankAccountNumber: '',
    },
    client: {
      clientId: '',
      email: '',
      fullName: '',
      partner: false,
      verified: false,
      wallets: [],
      accounts: [],
      exchanger: {
        id: '',
        frontName: '',
        balance: '',
      },
      isTest: false,
      isPremium: false,
    },
    clientPurse: {
      clientId: '',
      id: 0,
      expiry: '',
      isCard: false,
      verified: false,
      mask: '',
      type: '',
    },
    isAuto: false,
    isCard: false,
    processingProvider: '',
    processingMethod: '',
    status: '',
    initialAmount: '',
    initialCurrency: '',
    clientAmount: '',
    clientCurrency: '',
    companyAmount: '',
    companyCurrency: '',
    exchangeRate: '',
    clientCommission: '',
    companyCommission: '',
    commissionCurrency: '',
    innerCommission: '',
    createdAt: '',
    updatedAt: '',
    humanCreatedAt: '',
    humanUpdatedAt: '',
    externalTransferId: '',
    externalTransaction: {
      externalId: '',
    },
    externalPaymentTransaction: {
      externalId: '',
      externalStatus: '',
      initialAmount: '',
      initialCurrency: '',
      paidAmount: '',
      paidCurrency: '',
      vendorCommission: '',
      vendorCommissionCurrency: '',
      extraData: '',
    },
    providerId: '',
    psId: '',
    clientPurseId: 0,
    destinationType: '',
    rejectReason: '',
    psComment: '',
    managerComment: '',
    internalComment: '',
    destinationId: 0,
    changeHistory: {
      id: '',
      user: {
        email: '',
        fullName: '',
      },
    },
    changeHistoryAll: [],
    order: {
      orderId: 0,
      transactionRequestId: 0,
      gatewayId: 0,
      status: '',
      backendStatus: '',
      amount: 0,
      orderItems: [],
    },
    product: '',
    confirmedByManagerAt: '',
    confirmedByVendorAt: '',
    humanConfirmedByManagerAt: '',
    humanConfirmedByVendorAt: '',
    estimatedCommission: '',
    withdrawalDecisions: {
      decisionID: 0,
      transactionRequestID: 0,
      status: 0,
      startedAt: 0,
      endedAt: 0,
      checks: [],
      approved: false,
    },
  },
})
export const $withdrawal = restore(setWithdrawal, {
  transactionId: '',
  gatewayId: '',
  clientId: '',
  dealerApprovalStatus: '',
  gateway: {
    gatewayId: 0,
    name: '',
    internalName: '',
    paymentMethodType: '',
    processingProvider: '',
    withdrawalGroupId: 0,
    exchanger: {
      id: '',
      frontName: '',
      balance: '',
    },
  },
  formData: {
    amount: '',
    address: '',
    toBankAccountName: '',
    toBankAccountNumber: '',
  },
  client: {
    clientId: '',
    email: '',
    fullName: '',
    partner: false,
    verified: false,
    wallets: [],
    accounts: [],
    exchanger: {
      id: '',
      frontName: '',
      balance: '',
    },
    isTest: false,
    isPremium: false,
  },
  clientPurse: {
    clientId: '',
    id: 0,
    expiry: '',
    isCard: false,
    verified: false,
    mask: '',
    type: '',
  },
  isAuto: false,
  isCard: false,
  processingProvider: '',
  processingMethod: '',
  status: '',
  initialAmount: '',
  initialAmountUsd: '',
  initialCurrency: '',
  clientAmount: '',
  clientCurrency: '',
  companyAmount: '',
  companyCurrency: '',
  innerCommission: '',
  exchangeRate: '',
  clientCommission: '',
  companyCommission: '',
  commissionCurrency: '',
  createdAt: '',
  updatedAt: '',
  humanCreatedAt: '',
  humanUpdatedAt: '',
  externalTransferId: '',
  externalTransaction: {
    externalId: '',
  },
  externalPaymentTransaction: {
    externalId: '',
    externalStatus: '',
    initialAmount: '',
    initialCurrency: '',
    paidAmount: '',
    paidCurrency: '',
    vendorCommission: '',
    vendorCommissionCurrency: '',
    extraData: '',
  },
  providerId: '',
  psId: '',
  clientPurseId: 0,
  destinationType: '',
  rejectReason: '',
  psComment: '',
  managerComment: '',
  internalComment: '',
  destinationId: 0,
  mtTransactionId: 0,
  changeHistory: {
    id: '',
    user: {
      email: '',
      fullName: '',
    },
  },
  changeHistoryAll: [],
  order: {
    orderId: 0,
    transactionRequestId: 0,
    gatewayId: 0,
    status: '',
    backendStatus: '',
    amount: 0,
    orderItems: [],
  },
  product: '',
  confirmedByManagerAt: '',
  confirmedByVendorAt: '',
  humanConfirmedByManagerAt: '',
  humanConfirmedByVendorAt: '',
  estimatedCommission: '',
  withdrawalDecisions: {
    decisionID: 0,
    transactionRequestID: 0,
    status: 0,
    startedAt: 0,
    endedAt: 0,
    checks: [],
    approved: false,
  },
  formDataFieldSequenceOrder: [],
})

export const setError = createEvent<Error>()
export const setErrorAmount = createEvent<Error>()
export const setSuccess = createEvent<Error>()
export const submitSendClientToChat = createEvent<{
  id: number
  email: string
  name: string
  managerEmail: string
  clientUrl: string
}>()
export const submitSendWDWOTrading = createEvent<{
  id: number
  clientId: number
}>()

export const submitRequestForDealers = createEvent()

export const submitDisableAutoWithdrawal =
  createEvent<DisableAutoWithdrawalParams>()

export const getGateways = fx<void, GatewayResponse>({
  method: 'GET',
  url: `/gateway`,
})

export const getClientPurses = fx<string, ClientPurseResponse>({
  method: 'GET',
  url: `/client_purse?where={"clientId":"1"}`,
})

export const updateStatusWithdrawal = fx<
  WithdrawalApproveRequest,
  WithdrawalEdit
>({
  method: 'PUT',
  url: `/transaction_request/`,
})
export const rejectWithdrawal = fx<WithdrawalApproveRequest, WithdrawalEdit>({
  method: 'PUT',
  url: `/transaction_request/`,
})
export const rollbackWithdrawal = fx<WithdrawalApproveRequest, WithdrawalEdit>({
  method: 'PUT',
  url: `/transaction_request/`,
})

export const getWithdrawal = fx<void, WithdrawalEdit>({
  method: 'GET',
  url: '/transaction_request/',
})

export const updateWithdrawal = fx<WithdrawalEdit, WithdrawalEdit>({
  method: 'PUT',
  url: '/transaction_request/',
})

export const updateWithdrawalAmount = fx<AmountType, WithdrawalEdit>({
  method: 'PATCH',
  url: '/transaction_request/${id}',
})

export const getDividendBalance = fx<void, DividendBalance>({
  method: 'GET',
  url: '/nova/dividend_balance/',
})

export const updateWithdrawalProcessingMethod = fx<
  UpdateProcessingMethod,
  WithdrawalEdit
>({
  method: 'PATCH',
  url: '/transaction_request/${id}',
})

export const sendClientToChatFx = fx<
  {
    id: number
    email: string
    name: string
    managerEmail: string
    clientUrl: string
  },
  any
>({
  method: 'POST',
  baseUrl: env.baseUrl && env.baseUrl.replace('/v1', ''),
  url: '/tools/send-client-to-chat',
})

export const requestForDealers = fx<any, { dealerApprovalStatus: string }>({
  method: 'POST',
  url: '/transaction_request/{id}/request_dealer_check',
})

export const sendClientWDWOTrading = fx<
  {
    id: number
    clientId: number
  },
  any
>({
  method: 'PUT',
  url: '/transaction_request/notify_user_wd_without_trading/${id}',
})

export const setDisableAutoWithdrawalFx = fx<
  DisableAutoWithdrawalParams,
  ApiError
>({
  method: 'PUT',
  url: '/transaction_request',
})

export const getStatusGatewayByIdFx = fx<
  { id: number },
  GatewaysStatusResponse
>({
  method: 'GET',
  url: '/payment-traffic/statuses',
})

export const $disableAutoWithdrawalRequest = createStore<RequestState>({
  loading: false,
  success: false,
  error: '',
})
  .on(submitDisableAutoWithdrawal, () => ({
    loading: true,
    success: false,
    error: '',
  }))
  .on(setDisableAutoWithdrawalFx.done, () => ({
    loading: false,
    success: true,
    error: '',
  }))
  .on(setDisableAutoWithdrawalFx.failData, (_, error) => ({
    loading: false,
    success: false,
    error: error.body?.message ?? '',
  }))

export const $clientPurses = restore<ClientPurse[]>(
  getClientPurses.doneData.map((a) => a.body.items),
  [],
)

export const $gateways = restore<Gateway[]>(
  getGateways.doneData.map((a) => a.body.items),
  [],
)

export const $statusGateway = restore<GatewayCountries | null>(
  getStatusGatewayByIdFx.doneData.map(
    ({ body }): GatewayCountries | null =>
      Object.values(body.gateways)[0] ?? null,
  ),
  null,
)

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const $errorAmount = restore(setErrorAmount, {
  message: '',
  code: 0,
})
export const $success = restore(setSuccess, {
  message: '',
  code: 0,
})

export const $dividendBalance = restore<DividendBalance>(
  getDividendBalance.doneData.map((a) => a.body),
  dividendBalanceDefault,
)

sample({
  clock: setWithdrawal,
  filter: ({ gatewayId }) => Boolean(gatewayId),
  fn: ({ gatewayId }): any => {
    return {
      query: {
        where: JSON.stringify({ gateway: gatewayId }),
      },
    }
  },
  target: getStatusGatewayByIdFx,
})

sample({
  clock: submitSendClientToChat,
  fn: ({ id, email, name, managerEmail, clientUrl }) => ({
    body: { id, email, name, managerEmail, clientUrl },
  }),
  target: sendClientToChatFx,
})

sample({
  clock: submitSendWDWOTrading,
  fn: ({ id, clientId }) => ({
    id,
    clientId,
    url: `/transaction_request/notify_user_wd_without_trading/${id}`,
  }),
  target: sendClientWDWOTrading,
})

sample({
  clock: sendClientWDWOTrading.done,
  fn: ({ params }) => {
    // @ts-ignore
    const { id, clientId } = params
    const body = {
      entityType: 'client',
      message: `WD WO TRADING ${id}`,
      visibility: 'all',
      entityId: String(clientId),
      department: 'auto',
      type: 1,
    }
    return { body }
  },
  target: comment,
})

sample({
  clock: submitStatus,
  fn: ({ transactionId, status }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      body: {
        status: status,
      },
      url: `/transaction_request/${transactionId}`,
    }
  },
  target: updateStatusWithdrawal,
})

sample({
  clock: submitReject,
  fn: ({ transactionId }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      body: {
        status: 'STATUS_REJECTED',
      },
      url: `/transaction_request/${transactionId}`,
    }
  },
  target: rejectWithdrawal,
})

sample({
  clock: submitRollback,
  fn: ({ transactionId }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      body: {
        status: 'STATUS_ROLLBACK',
      },
      url: `/transaction_request/${transactionId}`,
    }
  },
  target: rollbackWithdrawal,
})

sample({
  clock: submitDisableAutoWithdrawal,
  fn: ({ transactionId }) => {
    return {
      url: `/transaction_request/disable_auto_withdrawal/${transactionId}`,
    }
  },
  target: setDisableAutoWithdrawalFx,
})

sample({
  clock: [
    withdrawalMounted,
    requestForDealers.doneData,
    setDisableAutoWithdrawalFx.done,
  ],
  source: $params,
  fn: (params) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'Client.exchanger',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
          'Gateway.name',
        ]),
      },
      url: `/transaction_request/${params?.withdrawalID}`,
    }
  },
  target: getWithdrawal,
})

sample({
  clock: [
    getWithdrawal.doneData,
    updateStatusWithdrawal.doneData,
    rejectWithdrawal.doneData,
    rollbackWithdrawal.doneData,
    updateWithdrawal.doneData,
  ],
  fn: (doneData) => doneData.body,
  target: [setWithdrawal],
})

sample({
  clock: [
    updateStatusWithdrawal.done,
    rejectWithdrawal.done,
    rollbackWithdrawal.done,
    updateWithdrawal.done,
  ],
  fn: () => {},
  target: [withdrawalMounted],
})

sample({
  clock: getWithdrawal.doneData,
  fn: (doneData) => ({
    amount: {
      initialAmount: new Decimal(doneData.body.initialAmount),
      initialCurrency: doneData.body.initialCurrency,
      initialCurrencyVisited: false,
      initialAmountVisited: false,
      clientAmount: new Decimal(doneData.body.clientAmount),
      clientCurrency: doneData.body.clientCurrency,
      clientAmountVisited: false,
      clientCurrencyVisited: false,
    },
    withdrawal: doneData.body,
  }),
  target: [setAmount],
})

sample({
  clock: submitEditWithdrawal,
  source: $params,
  fn: (params, withdrawal) => {
    let id
    if (params) {
      id = params.withdrawalID
    }
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
          'ExternalTransaction',
          'ExternalPaymentTransaction',
        ]),
      },
      url: `/transaction_request/${id}`,
      body: { ...withdrawal },
    }
  },
  target: updateWithdrawal,
})

sample({
  clock: submitEditWithdrawalAmount,
  source: $params,
  fn: (params, updateData) => {
    let id
    if (params) {
      id = params.withdrawalID
    }
    return {
      url: `/transaction_request/${id}`,
      body: {
        initialAmount: new Decimal(updateData.withdrawal.initialAmount),
        initialCurrency: updateData.withdrawal.initialCurrency,
        initialAmountVisited: updateData.amount.initialAmountVisited,
        initialCurrencyVisited: updateData.amount.initialCurrencyVisited,
        clientAmount: new Decimal(updateData.withdrawal.clientAmount),
        clientCurrency: updateData.withdrawal.clientCurrency,
        clientAmountVisited: updateData.amount.clientAmountVisited,
        clientCurrencyVisited: updateData.amount.clientCurrencyVisited,
      },
    }
  },
  target: updateWithdrawalAmount,
})

sample({
  // @ts-ignore
  clock: submitEditWithdrawalProcessingMethod,
  source: $params,
  fn: (params, updateData) => {
    let id
    if (params) {
      id = params.withdrawalID
    }
    return {
      url: `/transaction_request/${id}`,
      body: {
        id: id,
        gatewayId: updateData.gatewayId,
      },
    }
  },
  target: updateWithdrawalProcessingMethod,
})

sample({
  clock: [getWithdrawal.doneData],
  fn: (item) => {
    return {
      url: `/client_purse?where={"clientId":"${item.body.client.clientId}"}`,
    }
  },
  target: getClientPurses,
})

sample({
  // @ts-ignore
  clock: getWithdrawal.doneData,
  filter: (doneData) => {
    // @ts-ignore
    return doneData.body.gateway.withdrawalGroupId > 0
  },
  fn: (doneData) => {
    let query = {
      order: '',
      where: '',
    }
    // @ts-ignore
    query['where'] =
      `{"withdrawalGroupId": "` + doneData.body.gateway.withdrawalGroupId + `"}`
    // @ts-ignore
    query['order'] = '-id'
    return {
      query,
    }
  },
  target: getGateways,
})

sample({
  clock: updateWithdrawalProcessingMethod.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: updateWithdrawalProcessingMethod.doneData,
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setError],
})

sample({
  clock: updateWithdrawalAmount.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setErrorAmount],
})
sample({
  clock: updateWithdrawalAmount.failData,
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setSuccess],
})
sample({
  clock: updateWithdrawalAmount.doneData,
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setErrorAmount],
})
sample({
  clock: updateWithdrawalAmount.doneData,
  fn: (doneData) => {
    return {
      message: 'Withdrawal amount successfully updated',
      code: doneData.status,
    }
  },
  target: [setSuccess],
})

sample({
  clock: [getWithdrawal.doneData],
  filter: (doneData) => doneData.body.product === 'nova',
  fn: (doneData) => ({
    url: `/nova/dividend_balance/${doneData.body.clientId}`,
  }),
  target: [getDividendBalance],
})
sample({
  clock: [sendClientToChatFx.failData, sendClientWDWOTrading.failData],
  fn: (failData) => ({
    message: failData.body?.message || 'Error',
    code: failData.status,
  }),
  target: setError,
})

sample({
  clock: [sendClientToChatFx.doneData, sendClientWDWOTrading.doneData],
  fn: () => ({ message: 'Client sent to chat successfully', code: 200 }),
  target: setSuccess,
})

sample({
  // @ts-ignore
  clock: submitRequestForDealers,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.withdrawalID
    }

    return {
      url: `/transaction_request/${id}/request_dealer_check`,
    }
  },
  target: requestForDealers,
})

// Notifications for status change operations
sample({
  clock: [updateStatusWithdrawal.done, rejectWithdrawal.done, rollbackWithdrawal.done],
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: [updateStatusWithdrawal.fail, rejectWithdrawal.fail, rollbackWithdrawal.fail],
  fn: ({ error }) => ({
    message: (error as any)?.body?.message || (error as any)?.message || 'Unknown error',
    code: (error as any)?.status || 0,
  }),
  target: setRequestError,
})
